import axios from 'axios'
import {getENV, getParamsFromUrl, isEmpty} from './utils'
import weuijs from 'weui.js'
import {BASE_PARAMS, password, HOSID, OnlineHosid} from './config'
import {openidCache} from './cache'

export default function (service, data, method = 'post', loading = true) {
  let env = getENV()
  Log(`请求 ${service}`, data)

  let urlParams = getParamsFromUrl(location.href)
  let {query = {}} = urlParams
  data = Object.assign({}, BASE_PARAMS, data, {service}, {
    token: query.token || 'OPENID_PAT_' + openidCache.get(),
    openid: query.token || openidCache.get()
  })

  let _query = getParamsFromUrl(location.href).query || {}; //获取浏览器地址参数

  if(!isEmpty(_query)){
    //使用data中的医院id
    if(!data.noInsert){
      data.hosId = _query.hosId || HOSID; //平台医院id
    }
    if(service.indexOf('yygh') != -1){
      if(!data.noInsertYyid){
        data.hosId = _query.smartHosId ? _query.smartHosId : data.hosId //his医院id
        data.orgid = _query.smartHosId ? _query.smartHosId : data.orgid  //his医院id
        data.yyid = _query.smartHosId ? _query.smartHosId : data.orgid  //his医院id
      }
      data.hlwHosid = _query.hosId || HOSID
      data.openid = openidCache.get()
    }
    if(service.indexOf('doctorServicePblist') != -1){
      data.hosId = _query.smartHosId ?  _query.smartHosId : data.hosId//his医院id
    }

    if(!data.noInsertAppId){
      data.appid = _query.appId || env.appid ;
    }
  }

  let sign = hex_md5(hex_md5(password) + JSON.stringify(data))

  return new Promise((resolve, reject) => {
    // loading && (load = weuijs.loading('加载中...'));
    loading && (bus.$emit('loading', '加载中...'))
    let axiosConfig = {
      url: `${env.api}`,
      method,
      data,
      headers: {
        sign: sign
      }
    }
    axios(axiosConfig).then(res => {
      loading && (bus.$emit('loading', false))
      // loading && load.hide();
      if (res.status == 200) {
        Log(`响应 ${service}`, res.data)
        resolve(res.data)
      } else {
        weuijs.alert('错误代码:' + res.status)
        reject(res)
      }
    }).catch(errsr => {
      loading && (bus.$emit('loading', false))
      // loading && load.hide();
      Log('error', errsr)
      reject(errsr)
    })
  })
}



// WEBPACK FOOTER //
// ./src/lib/http.js